function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4 7.071l-3.89 3.89a.5.5 0 01-.707 0l-.707-.708a.5.5 0 010-.707l3.889-3.888-3.889-3.89a.5.5 0 010-.707l.707-.707a.5.5 0 01.707 0l3.889 3.89v-.001l1.061 1.06a.5.5 0 010 .707L10.4 7.071z"
})));